import * as R from "ramda";
import React, {Component} from "react";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import MasterLogistikTable from "../common/masterLogistikTable";
import {formGroupSegmen, tableConfig} from "../config";
import MasterLogistikMotorSegmenModifying from "./modal/MasterLogistikMotorSegmenModifying";
import Api from "../../../../Services/Api";
import {flattenFormGroupObject} from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";

class MasterLogistikMotorSegmen extends Component {
    constructor(props) {
        super(props);
        this.tableConfig = tableConfig.segmen
        this.state = {
            modifyingVisible: false,
            selectedData: null,
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            },
            errorUpdateStatus: false,
            errorMessage: null,
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataSegmen();
        this.handleTriggerLoading();
    }

    handleModifyingModalVisibility = (index) => {
        if (!R.isNil(index)) {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: {...prevValue.dataTable[index]},
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
    };

    handleSubmitModifying = async (data) => {
        this.handleTriggerLoading();
        let parsedData = {...flattenFormGroupObject(data)};
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").saveOrUpdateSegmen,
            menuName: "Master Logistik Motor - Segmen",
            setError: this.props.setError,
            args: parsedData,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.fetchDataSegmen({paramFilters: {}, limit: this.state.pagination.limit, page: this.state.pagination.page});
            this.handleModifyingModalVisibility();
        }
        this.handleTriggerLoading();
    };

    handleChangeStatus = async (index, value) => {
        this.handleTriggerLoading();
        let data = this.state.dataTable[index];
        data.status = value ? "ACTIVE" : "INACTIVE";
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateStatusSegmen,
            menuName: "Master Logistik Motor - Segmen",
            setError: this.props.setError,
            args: data,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.fetchDataSegmen({
                paramFilters: {},
                limit: this.state.pagination.limit,
                page: this.state.pagination.page,
            });
            if (res.data.code === 204) {
                this.handleShowErrorUpdate(res.data.data);
            }
        }
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangePage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        await this.fetchDataSegmen({paramFilters: {}, page: page, limit: limit});
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        await this.fetchDataSegmen({paramFilters: {}, page: page, limit: limit});
        this.handleTriggerLoading();
    }

    fetchDataSegmen = async (body) => {
        this.setState((prevValue) => ({...prevValue, isFetch: true, pagination: {...prevValue.pagination, count: 0}}));
        let req = body && Object.keys(body).length > 0
            ? body :
            {
                paramFilters: {},
                page: 1,
                limit: 5,
            };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSegmenPaging,
            menuName: "Master Logistik Motor - Segmen",
            setError: this.props.setError,
            args: req,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data,
                pagination: {
                    ...prevState.pagination,
                    count: res.data.totalData,
                    limit: req.limit,
                    page: req.page,
                }
            }));
        }
        this.setState((prevValue) => ({...prevValue, isFetch: false}));
    }

    handleShowErrorUpdate = (errorMessage) => {
        this.setState((prevValue) => ({
            ...prevValue,
            errorMessage,
            errorUpdateStatus: !prevValue.errorUpdateStatus,
        }));
    };

    render() {
        return (
            <>
                <MasterLogistikTable
                    tableConfig={this.tableConfig}
                    menuAccess={this.props.menuAccess}
                    data={this.state.dataTable}
                    onEdit={this.handleModifyingModalVisibility}
                    onChangeStatus={this.handleChangeStatus}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    pagination={this.state.pagination}
                    additionalButtons={
                        this.props.menuAccess && this.props.menuAccess.createAccess && (
                            <SimpleButton
                                onClick={() => this.handleModifyingModalVisibility()}
                                icon={<i className="fa fa-plus margin-right-10px"></i>}
                                text={"Tambah"}
                            />
                        )
                    }
                />

                {this.state.modifyingVisible && (
                    <MasterLogistikMotorSegmenModifying
                        formGroup={formGroupSegmen}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                {this.state.errorUpdateStatus && (
                    <SimpleAlert
                        visible={this.state.errorUpdateStatus}
                        title={"Peringatan"}
                        content={this.state.errorMessage}
                        onClickClose={() => this.handleShowErrorUpdate(null)}
                        additionalButtons={
                            <SimpleButton
                                type="button"
                                text="OK"
                                onClick={() => this.handleShowErrorUpdate(null)}
                            />
                        }
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default MasterLogistikMotorSegmen;
